import { render, staticRenderFns } from "./orderProce.vue?vue&type=template&id=50f51b9c&"
import script from "./orderProce.vue?vue&type=script&lang=ts&"
export * from "./orderProce.vue?vue&type=script&lang=ts&"
import style0 from "./orderProce.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports